// extracted by mini-css-extract-plugin
module.exports = {"paging":"styles_paging__1TBMZ","activeItem":"styles_activeItem__2txc0"};